module.exports = __webpack_public_path__ + "static/img/meetJack.8df6908f.png";